exports.MATERIAL_2014 = require('./2014.js')

exports.decodeColor = ([l, a, b, c, h]) => ({ l, a, b, c, h })
